module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/help-to-buy-wales-a1cc523b92fe540e3d5caba35184538d.jpg";